import styled from 'styled-components'

export const Fieldset = styled.fieldset`
  padding: 1rem 0 1rem;
  display: flex;
  justify-content: space-between;
`
